var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentShared(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.7061C28 18.4309 27.4123 19.0186 26.6875 19.0186H15.3125C14.5876 19.0186 14 18.4309 14 17.7061C14 16.9812 14.5876 16.3936 15.3125 16.3936H26.6875C27.4123 16.3936 28 16.9812 28 17.7061Z",
    fill: "#FCC21B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.7063C24.5 25.4311 23.9123 26.0188 23.1875 26.0188H15.3125C14.5876 26.0188 14 25.4311 14 24.7063C14 23.9814 14.5876 23.3938 15.3125 23.3938H23.1875C23.9123 23.3938 24.5 23.9814 24.5 24.7063Z",
    fill: "#FCC21B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1.95605C15.567 1.95605 14 3.52306 14 5.45605H10.5C8.567 5.45605 7 7.02306 7 8.95605V35.2061C7 37.1391 8.567 38.7061 10.5 38.7061H31.5C33.4331 38.7061 35 37.1391 35 35.2061V8.95605C35 7.02306 33.4331 5.45605 31.5 5.45605H28C28 3.52306 26.4331 1.95605 24.5 1.95605H17.5ZM25.375 5.45605C25.375 4.97281 24.9832 4.58105 24.5 4.58105H17.5C17.0168 4.58105 16.625 4.97281 16.625 5.45605V8.08105C16.625 8.5643 17.0168 8.95605 17.5 8.95605H24.5C24.9832 8.95605 25.375 8.5643 25.375 8.08105V5.45605ZM28 8.08105C28 10.0141 26.4331 11.5811 24.5 11.5811H17.5C15.567 11.5811 14 10.0141 14 8.08105H10.5C10.0168 8.08105 9.625 8.47281 9.625 8.95605V35.2061C9.625 35.6892 10.0168 36.0811 10.5 36.0811H31.5C31.9832 36.0811 32.375 35.6892 32.375 35.2061V8.95605C32.375 8.47281 31.9832 8.08105 31.5 8.08105H28Z",
    fill: "#FCC21B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentShared);
export default __webpack_public_path__ + "static/media/recent-shared.843bac7d54e1c1e6385199b5aecaa343.svg";
export { ForwardRef as ReactComponent };